import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExplosion: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="explosion, boom, bang, pop"><path d="M12 2.75L14.1239 6.87247L18.5407 5.45926L17.1275 9.87611L21.25 12L17.1275 14.1239L20.2763 20.2763L14.1239 17.1275L12 21.25L9.87611 17.1275L5.45926 18.5407L6.87247 14.1239L2.75 12L6.87247 9.87611L3.72368 3.72368L9.87611 6.87247L12 2.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconExplosion;
